export default {
  plans: {
    tier1: {
      promoted: false,
      title: 'Base',
      trial_days: 7,
    },
    tier2: {
      promoted: false,
      title: 'Plus',
      trial_days: 7,
    },
    tier3: {
      promoted: true,
      title: 'Pro',
      trial_days: 0,
    },
  },
  prices: {

    /**
     * BASE
     */

    tier1_monthly_usd: {
      amount: 6.99,
      plan_uuid: process.env.REACT_APP_TIER1_MONTHLY_USD,
    },
    tier1_yearly_usd: {
      amount: 64.99,
      plan_uuid: process.env.REACT_APP_TIER1_YEARLY_USD,
    },
    tier1_monthly_eur: {
      amount: 6.99,
      plan_uuid: process.env.REACT_APP_TIER1_MONTHLY_EUR,
    },
    tier1_yearly_eur: {
      amount: 64.99,
      plan_uuid: process.env.REACT_APP_TIER1_YEARLY_EUR,
    },
    tier1_monthly_chf: {
      amount: 6.99,
      plan_uuid: process.env.REACT_APP_TIER1_MONTHLY_CHF,
    },
    tier1_yearly_chf: {
      amount: 64.99,
      plan_uuid: process.env.REACT_APP_TIER1_YEARLY_CHF,
    },

    /**
     * PLUS
     */

    tier2_monthly_usd: {
      amount: 12.99,
      plan_uuid: process.env.REACT_APP_TIER2_MONTHLY_USD,
    },
    tier2_yearly_usd: {
      amount: 119.99,
      plan_uuid: process.env.REACT_APP_TIER2_YEARLY_USD,
    },
    tier2_monthly_eur: {
      amount: 12.99,
      plan_uuid: process.env.REACT_APP_TIER2_MONTHLY_EUR,
    },
    tier2_yearly_eur: {
      amount: 119.99,
      plan_uuid: process.env.REACT_APP_TIER2_YEARLY_EUR,
    },
    tier2_monthly_chf: {
      amount: 12.99,
      plan_uuid: process.env.REACT_APP_TIER2_MONTHLY_CHF,
    },
    tier2_yearly_chf: {
      amount: 119.99,
      plan_uuid: process.env.REACT_APP_TIER2_YEARLY_CHF,
    },

    /**
     * PRO
     */

    tier3_yearly_usd: {
      amount: 159.99,
      plan_uuid: process.env.REACT_APP_TIER3_YEARLY_USD,
    },
    tier3_yearly_eur: {
      amount: 159.99,
      plan_uuid: process.env.REACT_APP_TIER3_YEARLY_EUR,
    },
    tier3_yearly_chf: {
      amount: 159.99,
      plan_uuid: process.env.REACT_APP_TIER3_YEARLY_CHF,
    },

  },
  features: [
    {
      label: {
        en: 'Plan, save, and customise training sessions with professional drills',
        de: 'Plane, speichere und passe Trainingseinheiten mit professionellen Übungen individuell an',
        es: 'Planifica, guarda y personaliza sesiones de entrenamiento con ejercicios profesionales',
        it: 'Pianifica, salva e personalizza le sessioni di allenamento con esercizi professionali',
        pl: 'Planuj, zapisuj i dostosowuj sesje treningowe z profesjonalnymi ćwiczeniami',
        jp: 'プロ仕様のドリルでトレーニングセッションを計画、保存、カスタマイズしよう',
        cn: '使用专业训练课程规划、保存和自定义训练课程',
      },
      tier1: true,
      tier2: true,
      tier3: true,
    },
    {
      label: {
        en: 'Invite players & staff, communicate with your team and stay on top of everything',
        de: 'Lade Spieler und Trainer ein, kommuniziere mit deinem Team und behalte den Überblick über alles',
        es: 'Invita a jugadores y personal, comunícate con tu equipo y mantente al tanto de todo',
        it: 'Invita giocatori e staff, comunica con la tua squadra e resta sempre aggiornato',
        pl: 'Zaproś zawodników i sztab, komunikuj się z zespołem i miej wszystko pod kontrolą',
        jp: '選手やスタッフを招待し、チームと連絡を取り合い、すべてを把握しましょう',
        cn: '邀请球员和工作人员，与您的团队沟通，并掌握一切',
      },
      tier1: true,
      tier2: true,
      tier3: true,
    },
    {
      label: {
        en: 'Access a library of expert-designed drills and coaching resources',
        de: 'Greife auf eine Bibliothek mit professionell entwickelten Übungen und Coaching-Ressourcen zu',
        es: 'Accede a una biblioteca de ejercicios y recursos de entrenamiento diseñados por expertos',
        it: 'Accedi a una libreria di esercizi e risorse di coaching progettati da esperti',
        pl: 'Uzyskaj dostęp do biblioteki ćwiczeń i materiałów szkoleniowych opracowanych przez ekspertów',
        jp: '専門家が設計したドリルやコーチングリソースのライブラリにアクセスする',
        cn: '访问专家设计的训练课程和教练资源库',
      },
      tier1: true,
      tier2: true,
      tier3: true,
    },
    {
      label: {
        en: 'Export player stats, skill profiles and monitor team performance and participation trends',
        de: 'Exportiere Spielerstatistiken und Fähigkeitsprofile und überwache die Teamleistung sowie Teilnahmetrends',
        es: 'Exporta estadísticas de jugadores, perfiles de habilidades y supervisa el rendimiento y la participación del equipo',
        it: 'Esporta statistiche dei giocatori, profili delle abilità e monitora le prestazioni e la partecipazione della squadra',
        pl: 'Eksportuj statystyki zawodników, profile umiejętności oraz monitoruj wydajność i frekwencję zespołu',
        jp: '選手の統計、スキルプロフィールをエクスポートし、チームのパフォーマンスと参加傾向をモニタリングします',
        cn: '导出球员统计数据、技能档案，并监控团队绩效和参与趋势',
      },
      tier1: true,
      tier2: true,
      tier3: true,
    },
    {
      label: {
        en: 'invite players to team, manage availability and stay on top of planning and team management ',
        de: 'Spieler ins Team einladen, Verfügbarkeiten verwalten und den Überblick über Planung und Teammanagement behalten',
        es: 'Invita a jugadores al equipo, gestiona la disponibilidad y mantén el control de la planificación y la gestión del equipo.',
        it: 'Invita i giocatori nella squadra, gestisci la disponibilità e tieni sotto controllo la pianificazione e la gestione del team.',
        pl: 'Zaproś zawodników do zespołu, zarządzaj dostępnością i miej kontrolę nad planowaniem i zarządzaniem drużyną.',
        jp: '選手をチームに招待し、出欠を管理して、計画とチーム運営を把握しましょう。',
        cn: '邀请球员加入团队，管理可用性，并掌握计划和团队管理',
      },
      tier1: true,
      tier2: true,
      tier3: true,
    },
    {
      label: {
        en: 'take feedback from players, undertake surveys and make them part of team performance improvement',
        de: 'Rückmeldungen von Spielern einholen, Umfragen durchführen und sie in die Verbesserung der Teamleistung einbeziehen.',
        es: 'Recibir retroalimentación de los jugadores, realizar encuestas e integrarlos en la mejora del rendimiento del equipo.',
        it: 'Raccogliere feedback dai giocatori, condurre sondaggi e renderli parte del miglioramento delle prestazioni della squadra.',
        pl: 'Zbieraj opinie od zawodników, przeprowadzaj ankiety i włącz ich w proces poprawy wyników zespołu.      ',
        jp: '選手からフィードバックを受け取り、アンケートを実施して、チームのパフォーマンス向上に参加させましょう。',
        cn: '从球员那里获取反馈，进行调查，并让他们成为团队绩效改进的一部分',
      },
      tier1: false,
      tier2: true,
      tier3: true,
    },
    {
      label: {
        en: 'Build your own drills, videos and knowledge resources and keep your team engaged',
        de: 'Erstelle eigene Übungen, Videos und Wissensinhalte und halte dein Team engagiert',
        es: 'Crea tus propios ejercicios, vídeos y recursos de conocimiento y mantiene a tu equipo comprometido',
        it: 'Crea i tuoi esercizi, video e risorse di conoscenza e mantieni il tuo team coinvolto',
        pl: 'Twórz własne ćwiczenia, filmy i zasoby wiedzy, aby utrzymać zaangażowanie zespołu',
        jp: '独自のドリル、ビデオ、知識リソースを作成して、チームのモチベーションを維持しましょう',
        cn: '构建您自己的训练课程、视频和知识资源，并让您的团队保持参与',
      },
      tier1: false,
      tier2: true,
      tier3: true,
    },
    {
      label: {
        en: 'Manage lineups, add ratings, notes, and match highlights',
        de: 'Verwalte Aufstellungen, füge Bewertungen, Notizen und Spiel-Highlights hinzu',
        es: 'Gestiona las alineaciones, añade calificaciones, notas y momentos destacados del partido',
        it: 'Gestisci le formazioni, aggiungi valutazioni, note e momenti salienti della partita',
        pl: 'Zarządzaj składami, dodawaj oceny, notatki i najciekawsze momenty meczu',
        jp: 'メンバーを管理し、評価、メモ、試合のハイライトを追加する',
        cn: '管理阵容，添加评分、笔记和比赛亮点',
      },
      tier1: false,
      tier2: true,
      tier3: true,
    },
    {
      label: {
        en: 'Edit match videos, assign to players, matches and level up team performance',
        de: 'Bearbeite Spielvideos, ordne sie Spielern und Spielen zu und steigere die Teamleistung',
        es: 'Edita videos de partidos, asígnalos a jugadores y partidos, y mejora el rendimiento del equipo',
        it: 'Modifica i video delle partite, assegnali ai giocatori e alle partite, e migliora le prestazioni della squadra',
        pl: 'Edytuj nagrania meczów, przypisuj je do zawodników i meczów, i podnieś wydajność zespołu',
        jp: '「試合動画を編集し、選手や試合に割り当てて、チームのパフォーマンスを向上させましょう」',
        cn: '编辑比赛视频，分配给球员和比赛，并提升团队表现',
      },
      tier1: false,
      tier2: false,
      tier3: true,
    },
  ],
  addons: {
    cfg_yearly_usd: {
      amount: 59.99,
      plan_uuid: process.env.REACT_APP_CFG_ADDON_YEARLY_USD,
      trial_days: 0,
    },
    cfg_yearly_eur: {
      amount: 59.99,
      plan_uuid: process.env.REACT_APP_CFG_ADDON_YEARLY_EUR,
      trial_days: 0,
    },
    cfg_yearly_chf: {
      amount: 59.99,
      plan_uuid: process.env.REACT_APP_CFG_ADDON_YEARLY_CHF,
      trial_days: 0,
    },
  },
}
